/* eslint-disable react/jsx-no-duplicate-props */
import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useMediaQuery } from 'react-responsive';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import DefaultInput from '../../customUI/DefaultInput';
import PrimaryButton from '../../customUI/PrimaryButton';
import Sidebar from '../sidebar/Sidebar';
import GroupImage from '../groupImage/GroupImage';
import { authActions } from '../../store/auth-reducer';
import { storeContext } from '../provider/Provider';
import messageSent from '../../images/messageSent.png';
import theme from '../../theme';
import MobileTitle from '../../customUI/MobileTitle';

const { REACT_APP_AUTH0_API_URL } = process.env;

const useStyles = makeStyles(() => ({
  loginInput: {
    marginTop: 20,
  },
  sidebarContent: {
    margin: 20,
    textAlign: 'center',
    fontSize: 16,
  },
  loginSubmitButton: {
    marginTop: 30,
    width: 160,
    backgroundColor: '#00B5E2',
    height: 42,
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 10,
  },
  blackLinkBack: {
    textAlign: 'center',
    color: 'black',
    textDecoration: 'none',
    userSelect: 'none',
    cursor: 'pointer',
    fontSize: 14,
  },
  blackLinkAccount: {
    textAlign: 'center',
    color: 'black',
    textDecoration: 'none',
    userSelect: 'none',
    marginTop: 10,
    marginBottom: 5,
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 600,
  },
  messageSentImage: {
    display: 'block',
    margin: 'auto',
  },
  mobileFlex: {
    background: 'white',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  requirements: {
    display: 'none',
    transition: 'opacity 1s',
    textAlign: 'center',
    margin: 'auto',
    '& p': {
      color: theme.palette.secondary.main,
      textAlign: 'left',
    },
    '& p.filled': {
      color: theme.palette.primary.main,
      textAlign: 'left',
    },
  },
}));

const ResetPassword = () => {
  const isPhone = useMediaQuery({ query: '(max-width: 768px)' });
  const classes = useStyles();
  const { state, dispatch } = React.useContext(storeContext);
  const [disabledButton, ChangeDisabledButton] = React.useState(true);
  const history = useHistory();
  const { email, code } = useParams();
  const location = useLocation();

  useEffect(() => {
    if (email && code) {
      dispatch({
        type: authActions.SET_CHANGE_PASSWORD_PAGE_EMAIL_INPUT,
        payload: { emailInput: email },
      });
      dispatch({
        type: authActions.SET_CHANGE_PASSWORD_PAGE_CODE_INPUT,
        payload: { codeInput: code },
      });
      dispatch({
        type: authActions.SET_IS_EMAIL_PROVIDED,
        payload: { isEmailProvided: true },
      });
      dispatch({
        type: authActions.SET_IS_CODE_FROM_URL,
        payload: { isCodeFromUrl: true },
      });
      if (location.pathname.includes('register')) {
        history.push('/register');
      } else {
        history.push('/reset-password');
      }
    }
    // eslint-disable-next-line
  }, []);

  const validateField = (text) => text.length !== 0;

  const handleNewPasswordInputChange = (e) => {
    dispatch({
      type: authActions.SET_CHANGE_PASSWORD_PAGE_NEW_PASSWORD_INPUT,
      payload: { newPasswordInput: e.target.value },
    });
  };

  const handleSubmitEmailButtonClick = (e) => {
    e.preventDefault();
    if (validateField(state.auth.passwordChange.emailInput)) {
      axios
        .post(`${REACT_APP_AUTH0_API_URL}/auth/reset-password`, {
          username: state.auth.passwordChange.emailInput,
        })
        .then((res) => {
          if (res.data.success) {
            dispatch({
              type: authActions.SET_IS_EMAIL_PROVIDED,
              payload: { isEmailProvided: true },
            });
          } else {
            dispatch({
              type: authActions.SET_CHANGE_PASSWORD_PAGE_EMAIL_INPUT_ERROR,
              payload: { emailInputError: "We couldn't find this email", isEmailInputError: true },
            });
          }
        });
    } else {
      dispatch({
        type: authActions.SET_CHANGE_PASSWORD_PAGE_EMAIL_INPUT_ERROR,
        payload: { emailInputError: 'Email cannot be empty', isEmailInputError: true },
      });
    }
  };

  const handleEmailInputChange = (e) => {
    if (e.key === 'Enter') {
      handleSubmitEmailButtonClick();
    } else {
      dispatch({
        type: authActions.SET_CHANGE_PASSWORD_PAGE_EMAIL_INPUT,
        payload: { emailInput: e.target.value },
      });
    }
  };

  const handleSubmitNewPasswordButtonClick = () => {
    if (validateField(state.auth.passwordChange.newPasswordInput)) {
      axios
        .post(`${REACT_APP_AUTH0_API_URL}/auth/confirm-reset-password`, {
          code: state.auth.passwordChange.codeInput,
          password: state.auth.passwordChange.newPasswordInput,
          username: state.auth.passwordChange.emailInput,
        })
        .then((res) => {
          if (res.data.success) {
            dispatch({
              type: authActions.SET_IS_PASSWORD_CHANGED,
              payload: { isPasswordChanged: true },
            });
          } else if (res.data.message.search('ExpiredCodeException') !== -1) {
            dispatch({
              type: authActions.SET_CHANGE_PASSWORD_PAGE_NEW_PASSWORD_INPUT_ERROR,
              payload: {
                newPasswordInputError:
                  'Token Expired Error, please go to /reset-password to reset your password',
                isNewPasswordInputError: true,
              },
            });
          } else if (res.data.message.search('LimitExceededException') !== -1) {
            dispatch({
              type: authActions.SET_CHANGE_PASSWORD_PAGE_NEW_PASSWORD_INPUT_ERROR,
              payload: {
                newPasswordInputError: 'Attempt limit exceeded, please try after some time.',
                isNewPasswordInputError: true,
              },
            });
          } else {
            dispatch({
              type: authActions.SET_CHANGE_PASSWORD_PAGE_NEW_PASSWORD_INPUT_ERROR,
              payload: {
                newPasswordInputError:
                  'Password not secure - please make sure your password contains a least one uppercase letter, lowercase letter, number, and symbol',
                isNewPasswordInputError: true,
              },
            });
          }
        });
    } else {
      dispatch({
        type: authActions.SET_CHANGE_PASSWORD_PAGE_NEW_PASSWORD_INPUT_ERROR,
        payload: {
          newPasswordInputError: 'Password cannot be empty',
          isNewPasswordInputError: true,
        },
      });
    }
  };

  const handleEmailInputFocus = () => {
    dispatch({
      type: authActions.SET_CHANGE_PASSWORD_PAGE_EMAIL_INPUT_ERROR,
      payload: { emailInputError: '', isEmailInputError: false },
    });
  };
  const handleNewPasswordInputFocus = () => {
    dispatch({
      type: authActions.SET_CHANGE_PASSWORD_PAGE_NEW_PASSWORD_INPUT_ERROR,
      payload: { newPasswordInputError: '', isNewPasswordInputError: false },
    });
  };

  const handleBackButtonClick = () => {
    dispatch({ type: authActions.CLEAR_PASSWORD_CHANGE });
    history.push('/login');
  };

  const handleDontHaveAccount = () => {};

  function CheckRequirements(val) {
    let issues = 0;
    if (val === '') {
      document.getElementById('requirements').style.opacity = '0';
      setTimeout(() => {
        document.getElementById('requirements').style.display = 'none';
      }, 1000);
    } else {
      document.getElementById('requirements').style.display = 'block';
      setTimeout(() => {
        document.getElementById('requirements').style.opacity = '1';
      }, 50);
    }
    if (/\d/.test(val)) {
      document.getElementById('reqNum').classList.add('filled');
    } else {
      document.getElementById('reqNum').classList.remove('filled');
      issues += 1;
    }
    if (/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>`/?]+/.test(val)) {
      document.getElementById('reqSym').classList.add('filled');
    } else {
      document.getElementById('reqSym').classList.remove('filled');
      issues += 1;
    }
    if (/[A-Z]/.test(val)) {
      document.getElementById('reqUpper').classList.add('filled');
    } else {
      document.getElementById('reqUpper').classList.remove('filled');
      issues += 1;
    }
    if (val.length > 7) {
      document.getElementById('reqLen').classList.add('filled');
    } else {
      document.getElementById('reqLen').classList.remove('filled');
      issues += 1;
    }
    if (issues !== 0) {
      ChangeDisabledButton(true);
    } else {
      ChangeDisabledButton(false);
    }
  }

  if (isPhone) {
    return (
      <div style={{ width: '100%', background: 'white' }}>
        <MobileTitle
          title={location.pathname.includes('register') ? 'Register' : 'Reset Password'}
        />
        <div className={classes.mobileFlex}>
          {!state.auth.passwordChange.isEmailProvided && !state.auth.passwordChange.isCodeProvided && (
            <>
              <form className={classes.sidebarContent} noValidate>
                <DefaultInput
                  fullWidth
                  label="Email"
                  variant="outlined"
                  className={classes.loginInput}
                  onFocus={handleEmailInputFocus}
                  onKeyPress={handleEmailInputChange}
                  data-testid="reset_password_testid"
                  value={state.auth.passwordChange.emailInput}
                  error={state.auth.passwordChange.isEmailInputError}
                  helperText={state.auth.passwordChange.emailInputError}
                />
                <div className={classes.buttonWrapper}>
                  <PrimaryButton
                    variant="contained"
                    color="primary"
                    className={classes.loginSubmitButton}
                    type="submit"
                    onClick={handleSubmitEmailButtonClick}
                    style={{ width: '100%' }}
                  >
                    Continue
                  </PrimaryButton>
                </div>
              </form>
              <div
                className={classes.blackLinkBack}
                onClick={handleBackButtonClick}
                aria-hidden="true"
              >
                Back
              </div>
              <div
                onClick={handleDontHaveAccount}
                className={classes.blackLinkAccount}
                aria-hidden="true"
              >
                Don&apos;t have an account yet?
              </div>
            </>
          )}
          {state.auth.passwordChange.isEmailProvided &&
            !state.auth.passwordChange.isPasswordChanged && (
              <>
                <form className={classes.sidebarContent} noValidate>
                  {!state.auth.passwordChange.isCodeFromUrl && (
                    <>
                      <img src={messageSent} alt="" className={classes.messageSentImage} />
                      We have sent an email to {state.auth.passwordChange.emailInput}. Please follow
                      the instructions in email to reset your password.
                    </>
                  )}
                  {state.auth.passwordChange.isCodeFromUrl && (
                    <>
                      <DefaultInput
                        fullWidth
                        label="New Password"
                        variant="outlined"
                        type="password"
                        className={classes.loginInput}
                        onFocus={handleNewPasswordInputFocus}
                        onKeyUp={(e) => {
                          CheckRequirements(e.target.value);
                        }}
                        onChange={handleNewPasswordInputChange}
                        value={state.auth.passwordChange.newPasswordInput}
                        error={state.auth.passwordChange.isNewPasswordInputError}
                        helperText={state.auth.passwordChange.newPasswordInputError}
                      />
                      <div className={classes.requirements} id="requirements">
                        <p id="reqUpper">
                          <InfoOutlinedIcon /> At least 1 uppercase letter is required.
                        </p>
                        <p id="reqNum">
                          <InfoOutlinedIcon /> At least 1 number is required.
                        </p>
                        <p id="reqSym">
                          <InfoOutlinedIcon /> At least 1 symbol is required.
                        </p>
                        <p id="reqLen">
                          <InfoOutlinedIcon /> At least 8 characters are required.
                        </p>
                      </div>
                      <div className={classes.buttonWrapper}>
                        <PrimaryButton
                          variant="contained"
                          color="primary"
                          className={classes.loginSubmitButton}
                          onClick={handleSubmitNewPasswordButtonClick}
                          style={{ width: '100%' }}
                          disabled={disabledButton}
                        >
                          Continue
                        </PrimaryButton>
                      </div>
                    </>
                  )}
                </form>
              </>
            )}
          {state.auth.passwordChange.isPasswordChanged && (
            <div className={classes.sidebarContent}>
              The password for {state.auth.passwordChange.emailInput} was successfully changed.
              <PrimaryButton
                variant="contained"
                color="primary"
                className={classes.loginSubmitButton}
                onClick={handleBackButtonClick}
                style={{ width: '100%' }}
              >
                Log In
              </PrimaryButton>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <>
      <Sidebar>
        {!state.auth.passwordChange.isEmailProvided && !state.auth.passwordChange.isCodeProvided && (
          <>
            <form
              className={classes.sidebarContent}
              noValidate
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <DefaultInput
                fullWidth
                label="Email"
                variant="outlined"
                className={classes.loginInput}
                onFocus={handleEmailInputFocus}
                onChange={handleEmailInputChange}
                data-testid="reset_password_testid"
                value={state.auth.passwordChange.emailInput}
                error={state.auth.passwordChange.isEmailInputError}
                helperText={state.auth.passwordChange.emailInputError}
              />
              <div className={classes.buttonWrapper}>
                <PrimaryButton
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.loginSubmitButton}
                  type="submit"
                  onClick={handleSubmitEmailButtonClick}
                >
                  Continue
                </PrimaryButton>
              </div>
            </form>
            <div
              className={classes.blackLinkBack}
              onClick={handleBackButtonClick}
              aria-hidden="true"
            >
              Back
            </div>
            <div
              onClick={handleDontHaveAccount}
              className={classes.blackLinkAccount}
              aria-hidden="true"
            >
              Don&apos;t have an account yet?
            </div>
          </>
        )}
        {state.auth.passwordChange.isEmailProvided && !state.auth.passwordChange.isPasswordChanged && (
          <>
            <form
              className={classes.sidebarContent}
              noValidate
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              {!state.auth.passwordChange.isCodeFromUrl && (
                <>
                  <img src={messageSent} alt="" className={classes.messageSentImage} />
                  We have sent an email to {state.auth.passwordChange.emailInput}. Please follow the
                  instructions in email to reset your password.
                </>
              )}
              {state.auth.passwordChange.isCodeFromUrl && (
                <>
                  <DefaultInput
                    fullWidth
                    label="New Password"
                    variant="outlined"
                    type="password"
                    className={classes.loginInput}
                    onFocus={handleNewPasswordInputFocus}
                    onKeyUp={(e) => {
                      CheckRequirements(e.target.value);
                    }}
                    onChange={handleNewPasswordInputChange}
                    value={state.auth.passwordChange.newPasswordInput}
                    error={state.auth.passwordChange.isNewPasswordInputError}
                    helperText={state.auth.passwordChange.newPasswordInputError}
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        handleSubmitNewPasswordButtonClick();
                      }
                    }}
                  />
                  <div className={classes.requirements} id="requirements">
                    <p id="reqUpper">
                      <InfoOutlinedIcon /> At least 1 uppercase letter is required.
                    </p>
                    <p id="reqNum">
                      <InfoOutlinedIcon /> At least 1 number is required.
                    </p>
                    <p id="reqSym">
                      <InfoOutlinedIcon /> At least 1 symbol is required.
                    </p>
                    <p id="reqLen">
                      <InfoOutlinedIcon /> At least 8 characters are required.
                    </p>
                  </div>
                  <div className={classes.buttonWrapper}>
                    <PrimaryButton
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={disabledButton}
                      className={classes.loginSubmitButton}
                      onClick={handleSubmitNewPasswordButtonClick}
                    >
                      Continue
                    </PrimaryButton>
                  </div>
                </>
              )}
            </form>
          </>
        )}
        {state.auth.passwordChange.isPasswordChanged && (
          <div className={classes.sidebarContent}>
            The password for {state.auth.passwordChange.emailInput} was successfully changed.
            <PrimaryButton
              variant="contained"
              color="primary"
              className={classes.loginSubmitButton}
              onClick={handleBackButtonClick}
            >
              Log In
            </PrimaryButton>
          </div>
        )}
      </Sidebar>
      <GroupImage />
    </>
  );
};

export default ResetPassword;
